import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

export const getListNomination = (params) => sendGet("/nominations", params);
export const createNomination = (params) => sendPost("/nominations", params);

export const updateNomination = (id, params) =>
  sendPut(`/nominations/${id}`, params);

export const deleteNomination = (id) => sendDelete(`/nominations/${id}`);
